       
export class ChangePassword {
    UserName :string;
    OldPassword:string;
    NewPassword :string;
    ConfirmNewPassword :string;
};